<template>
	<div>
		<el-container>
			<el-aside width="200px">
				<sidebar></sidebar>
			</el-aside>
			<el-container>
				<el-header>
					<my-header></my-header>
				</el-header>
				<el-main>
					<router-view>
					</router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import myHeader from '../../components/main/myHeader.vue';
	import myFooter from '../../components/main/myFooter.vue';
	import sidebar from "../../components/main/sideBar.vue"

	export default {
		data() {
			return {
				navMenu: [{
					title: "基本信息",
					path: "/home"
				}, {
					title: "电子证书",
					path: "/listpage"
				}, {
					title: "我要投稿",
					path: "/listpage"
				}, {
					title: "通知公告",
					path: "/listpage"
				}, {
					title: "会费记录",
					path: "/home"
				}, {
					title: "意见反馈",
					path: "/home"
				}]
			}
		},
		components: {
			myHeader,
			myFooter,
			sidebar
		},
		methods: {
			// 测试
			showError() {
				
			}
		}
	}
</script>

<style scoped>
	.el-header,
	.el-footer {
		padding: 0;
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
		line-height: 60px;
	}

	.el-aside {
		background-color: #1c2e43;
		color: #333;
		text-align: center;
		line-height: 200px;
		/* height: 100vh; */
		
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
	}

	.el-main {
		background-color: #ffffff;
		color: #333;
		text-align: center;
		/* line-height: 160px; */
		
		position: absolute;
		left:200px;
		right: 0;
		top: 60px;
		bottom: 0;
		overflow-y: scroll;
	}

	body>.el-container {
		margin-bottom: 40px;
	}

	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {
		line-height: 260px;
	}

	.el-container:nth-child(7) .el-aside {
		line-height: 320px;
	}
</style>
